export default "__VITE_PUBLIC_ASSET__ff0cabce__"